export default "__VITE_ASSET__DzoLI$Gf__"